"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Quote } from "lucide-react";
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const testimonials = [{
    author: "Jane D.",
    quote: "CashHome made selling my house quick and hassle-free. Highly recommended!",
    position: "Homeowner"
  }, {
    author: "Mike S.",
    quote: "I received an all-cash offer and closed in days. Excellent service!",
    position: "Satisfied Client"
  }];
  return <section id="testimonials" ref={ref} className="py-16 px-4 bg-background">
      <div className={`max-w-4xl mx-auto transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-12 text-foreground">
          What Our Clients Say
        </h2>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center text-center px-8 py-12 min-h-[300px]">
                  <Quote className="w-12 h-12 text-primary mb-6" />
                  <blockquote className="text-xl md:text-2xl font-sans text-foreground mb-6 leading-relaxed">
                    "{testimonial.quote}"
                  </blockquote>
                  <div className="mt-4">
                    <p className="font-display font-semibold text-lg text-foreground">
                      {testimonial.author}
                    </p>
                    <p className="text-muted-foreground text-sm mt-1">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex items-center justify-center gap-4 mt-8">
            <CarouselPrevious className="relative left-0 top-0 translate-x-0 translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" />
            <CarouselNext className="relative right-0 top-0 translate-x-0 translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" />
          </div>
        </Carousel>
      </div>
    </section>;
}